/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";

type DashboardSectionTitleProps = {
  title: string;
  subText?: string;
};

export const DashboardSectionTitle: React.FC<DashboardSectionTitleProps> = ({
  title,
  subText,
}) => {
  return (
    <div css={styles.titleWrap}>
      <span css={styles.titleIndicator} />
      <h3 css={styles.titleText}>{title}</h3>
      {subText && <span css={styles.titleSubText}>{subText}</span>}
    </div>
  );
};

const styles = {
  titleWrap: css`
    display: flex;
    align-items: center;
    gap: 11px;
  `,
  titleIndicator: css`
    width: 4px;
    height: 19px;
    background: #00897a;
    border-radius: 2px;
  `,
  titleText: css`
    margin: 0;
    color: #ffffff;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 0.8px;
  `,
  titleSubText: css`
    color: #66737f;
    font-size: 12.5px;
  `,
};
